import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from '../../../../services/configuration.service';

export interface UserCentreBrick { id: number; brickId: number; brickName: string; startDate: string; endDate?: string; isOpen: boolean; }
/** Where a user's centres come from today. */
export type CentreSource = 'BusinessUnit' | 'Exception' | 'Both' | 'Team' | 'None';
export interface UserCentreBricks {
  userId: number; businessUnitName: string; isManager: boolean; source: CentreSource;
  businessUnitCentres: string[]; exceptionCentres: string[];
  teamCentres: { brickName: string; businessUnitName: string }[]; links: UserCentreBrick[];
}
export interface UserCentreSummary { userId: number; count: number; source: CentreSource; }

@Injectable({ providedIn: 'root' })
export class UserCentreBricksService {
  constructor(private http: HttpClient, private configurations: ConfigurationService) { }
  private get api() { return this.configurations.apiAddress + '/api/UserCentreBrick/'; }

  summary() { return this.http.get<UserCentreSummary[]>(this.api + 'summary'); }
  forUser(userId: number) { return this.http.get<UserCentreBricks>(this.api + 'user/' + userId); }
  options(userId: number) { return this.http.get<{ id: number; name: string }[]>(this.api + 'options/' + userId); }
  add(userId: number, brickId: number, startDate: string) { return this.http.post(this.api + 'add', { userId, brickId, startDate }); }
  close(id: number, endDate: string) { return this.http.post(this.api + 'close', { id, endDate }); }
  remove(id: number) { return this.http.post(this.api + 'delete/' + id, {}); }
}
